import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import EditorConditionInputs from './EditorConditionInputs';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionBase = ({
  children,
  condition,
  conditionPath,
  dataSeleniumInfo,
  filterFamily,
  onConditionDelete,
  onConditionOperatorChange,
  onConditionValueChange,
  isRefinement,
  isRefinementEnabled,
  inputUse
}) => {
  return /*#__PURE__*/_jsx(EditorConditionActionsContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: filterFamily,
    onConditionDelete: onConditionDelete,
    isRefinement: isRefinement,
    children: /*#__PURE__*/_jsxs(ConditionBox, {
      isRefinement: isRefinement,
      children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
        condition: condition,
        dataSeleniumInfo: dataSeleniumInfo,
        filterFamily: filterFamily,
        inputUse: inputUse,
        onConditionOperatorChange: onConditionOperatorChange,
        onConditionValueChange: onConditionValueChange,
        isRefinement: isRefinement,
        isRefinementEnabled: isRefinementEnabled,
        children: children
      }), /*#__PURE__*/_jsx(ConditionError, {
        condition: condition
      }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
        condition: condition
      })]
    })
  });
};
export default EditorConditionBase;